import { useEffect, useState } from 'react';
import { Upload, Plane, CheckCircle2, AlertCircle, ArrowRight, Radar } from 'lucide-react';
import { listFlights } from '../../lib/flightSyncDb';
import { getWatchHandle, watchFolderSupported } from '../../lib/flightSyncWatch';

export default function HomePage({ ctx, onGoImport }) {
  const [stats, setStats] = useState({ total: 0, pending: 0, synced: 0 });
  const [lastSync, setLastSync] = useState(null);
  const [watchFolder, setWatchFolder] = useState(null);

  useEffect(() => {
    const load = async () => {
      const all = await listFlights();
      const pending = all.filter((f) => !f.synced);
      const synced = all.filter((f) => f.synced);
      setStats({ total: all.length, pending: pending.length, synced: synced.length });
      const lastSyncedItem = synced[0];
      setLastSync(lastSyncedItem?.synced_at || lastSyncedItem?.created_at || null);
    };
    load();
    getWatchHandle().then((h) => setWatchFolder(h?.name || null));
    const i = setInterval(load, 3000);
    return () => clearInterval(i);
  }, []);

  return (
    <div data-testid="fs-home-page">
      <div className="fs-hero">
        <div className="fs-hero-label">PROJETO ATIVO</div>
        <div className="fs-hero-value" style={{ fontSize: 22 }}>{ctx.project_name}</div>
        <div className="fs-hero-sub">
          Piloto: {ctx.pilot_name} · {ctx.drone_model}
        </div>
      </div>

      <div className="fs-grid cols-2">
        <div className="fs-card" style={{ marginBottom: 0 }}>
          <div className="fs-card-title">SYNCADOS</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--fs-green)', fontFamily: 'JetBrains Mono, monospace' }}>
            {stats.synced}
          </div>
        </div>
        <div className="fs-card" style={{ marginBottom: 0 }}>
          <div className="fs-card-title">PENDENTES</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--fs-amber)', fontFamily: 'JetBrains Mono, monospace' }}>
            {stats.pending}
          </div>
        </div>
      </div>

      <div style={{ height: 14 }} />

      <button className="fs-btn fs-btn-primary" style={{ width: '100%', padding: '18px' }} onClick={onGoImport} data-testid="fs-btn-import-home">
        <Upload size={18} /> IMPORTAR LOG DE VOO <ArrowRight size={16} />
      </button>

      {stats.total === 0 && (
        <div className="fs-card" style={{ marginTop: 14 }}>
          <div className="fs-card-title"><AlertCircle size={12} /> PRIMEIRO VOO</div>
          <p style={{ fontSize: 13, color: 'var(--fs-text-dim)', margin: 0, lineHeight: 1.6 }}>
            Exporte o .csv do DJI Fly (Perfil → Registro de voo → Exportar) e importe aqui.
            Os dados sao automaticamente enviados ao painel gestaoderpas.com.br em tempo real.
          </p>
        </div>
      )}

      {watchFolder ? (
        <div className="fs-card" style={{ marginTop: 14, borderColor: 'rgba(16,185,129,0.3)' }} data-testid="fs-watch-active-card">
          <div className="fs-card-title" style={{ color: 'var(--fs-green)' }}>
            <Radar size={12} /> MONITORAMENTO ATIVO
          </div>
          <p style={{ fontSize: 13, margin: 0 }}>
            Pasta: <strong>{watchFolder}</strong>
          </p>
          <p style={{ fontSize: 11, color: 'var(--fs-text-dim)', marginTop: 4, margin: 0 }}>
            Logs novos sao detectados automaticamente a cada 30s.
          </p>
        </div>
      ) : watchFolderSupported() && (
        <div className="fs-card" style={{ marginTop: 14, borderColor: 'rgba(0,212,255,0.3)' }}>
          <div className="fs-card-title"><Radar size={12} /> DICA</div>
          <p style={{ fontSize: 13, margin: 0 }}>
            Ative o <strong>monitoramento automatico</strong> em Ajustes para que novos voos sejam enviados sem precisar importar manualmente.
          </p>
        </div>
      )}

      {lastSync && (
        <div className="fs-card" style={{ marginTop: 14 }}>
          <div className="fs-card-title" style={{ color: 'var(--fs-green)' }}><CheckCircle2 size={12} /> ULTIMO SYNC</div>
          <p style={{ fontSize: 13, margin: 0 }}>{new Date(lastSync).toLocaleString('pt-BR')}</p>
        </div>
      )}
    </div>
  );
}
